import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';

import { AppProvider, Frame, Toast } from '@shopify/polaris';

const propTypes = {
  initialDisplay: PropTypes.bool,
  content: PropTypes.string,
};

const defaultProps = {
  initialDisplay: false
}


const SimpleToast = (props) => {
  [display, setDisplay] = useState(props.initialDisplay);
  // []
  toggleToast = () => setDisplay(!display)

  return(
  <Frame>
    <Toast 
      content={toastMessage} 
      onDismiss={toggleToast} />
  </Frame>
  );
}

SimpleToast.propTypes = propTypes;
SimpleToast.defaultProps = defaultProps;

export default SimpleToast;